import { motion } from "framer-motion";
import { Syringe, ArrowRight, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { EnsoCircle } from "./JapaneseMotifs";

export function VaccineSpotlight() {
  const { t } = useLang();
  const bullets = [t("spot_b1"), t("spot_b2"), t("spot_b3")];
  return (
    <section id="asi" className="relative bg-white py-24 sm:py-32 overflow-hidden" data-testid="vaccine-spotlight">
      <EnsoCircle className="absolute -right-24 top-1/2 -translate-y-1/2 w-[420px] h-[420px] text-brand opacity-[0.07] pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div initial={{ opacity: 0, x: -24 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}>
          <div className="flex items-center gap-2.5 text-xs font-heading font-bold tracking-[0.3em] uppercase text-brand mb-4">
            <Syringe size={15} /> {t("spot_kicker")}
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-ink text-balance">{t("spot_title")}</h2>
          <p className="mt-5 text-lg text-sub leading-relaxed">{t("spot_sub")}</p>
          <ul className="mt-7 space-y-3">
            {bullets.map((b, i) => (
              <li key={i} className="flex items-center gap-3 text-sm font-semibold text-ink/80" data-testid={`spot-bullet-${i}`}>
                <span className="w-6 h-6 rounded-full bg-brand/10 text-brand flex items-center justify-center shrink-0"><Check size={13} /></span>
                {b}
              </li>
            ))}
          </ul>
          <Link
            to="/tedavi/aftv"
            data-testid="spot-cta-link"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-ink hover:bg-brand text-white font-semibold text-sm px-7 py-3.5 transition-colors"
          >
            {t("spot_cta")} <ArrowRight size={16} />
          </Link>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="relative"
        >
          <img
            src="/img/aftv-vaccine.jpg"
            alt={t("spot_title")}
            data-testid="spot-image"
            className="w-full rounded-[2rem] shadow-2xl shadow-brand/15 border border-black/5 object-cover"
          />
        </motion.div>
      </div>
    </section>
  );
}
